import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Button from 'root/src/client/web/base/Button'
import classNames from 'classnames'
import Link from 'root/src/client/web/base/Link'
import ResponsiveImage from 'root/src/client/web/static/reusable/ResponsiveImage'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import SubHeader from 'root/src/client/web/typography/SubHeader'
import MaxWidthContainer from 'root/src/client/web/base/MaxWidthContainer'
import styles from './styles'

const Showcase = memo(({
	pageContent, isMobileRes, classes,
}) => {
	const {
		textPosition, title, description, button, image, videoUrl,
	} = pageContent

	const Controls = button && (
		<div className={classes.linkWrapper}>
			<Link routeId={button.routeId}>
				<Button>
					{button.text}
				</Button>
			</Link>
		</div>
	)

	return (
		(
			<div className={classes.wrapper}>
				<MaxWidthContainer>
					<div className={classNames(
						classes.row, classes.noPaddingMaxWidth, classes.marginBottomBig,
					)}
					>
						<div className={classNames(
							classes.textWrapper,
							{ [classes.textRight]: textPosition === 'right' },
						)}
						>
							<div className={classes.titleCenter}>
								<Typography
									variant={typographyVariants.heading1}
									style={{ letterSpacing: '0.02em' }}
								>
									{title}
								</Typography>
							</div>
							<SubHeader className={classes.subHeader}>
								{description}
							</SubHeader>
							{!isMobileRes && button && Controls}
						</div>
						<div className={classNames(
							classes.imageWrapper,
						)}
						>
							{image
								? (
									<ResponsiveImage
										imageObj={image}
										className={classes.image}
										alt="brandImage"
									/>
								)
								: (
									<div className={classes.iframeContainer}>
										<iframe
											src={videoUrl}
											title="tobii"
											className={classes.iframe}
										/>
									</div>
								)
							}
						</div>
						{isMobileRes && button && Controls}
					</div>
				</MaxWidthContainer>
			</div>
		)
	)
})

export default withStyles(styles, { name: 'MuiShowcase' })(Showcase)
